import React from 'react';

const Page404 = (props) => {
    return (
        <div>
            The page you looking for does not exists.
        </div>
    )
}

export default Page404